import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMyWorksToControl(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL,
    ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL].GET_MY_WORKS_TO_CONTROL,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL].GET_MY_WORKS_TO_CONTROL]: _getMyWorksToControl
}